
	import Ranking from '@/component/ranking/ranking.vue'
	import { loadInstanceTranslations, i18n } from '@/model/i18n'
	const messages = {
	"allies_killed": "Allies killed",
	"allies_killed_title": "Allies killed count",
	"br": "Battle Royales",
	"br_title": "Battle Royales won",
	"chips": "Chips",
	"chips_title": "Number of chips used",
	"connection_title": "Days connected",
	"clovers": "Clovers",
	"clovers_title": "Clovers found",
	"days": "Days",
	"distance": "Distance",
	"distance_title": "Total distance traveled",
	"farmers": "Farmers",
	"fights": "Fights",
	"fights_title": "Total number of fights",
	"fun": "Fun",
	"hide_inactives": "Hide inactives",
	"kills": "Kills",
	"kills_title": "Number of kills",
	"leeks": "Leeks",
	"money": "Money",
	"my_farmer": "My farmer",
	"my_leek": "My leek",
	"my_team": "My team",
	"place": "Rank",
	"results": "Results",
	"richest_title": "Money earned",
	"search_in_ranking": "Search in the ranking",
	"search_name": "Name",
	"shots": "Shots",
	"shots_title": "Total shots count",
	"summons": "Summons",
	"summons_title": "Summons summoned",
	"teams": "Teams",
	"title": "Ranking",
	"total_level": "Total level",
	"trophies": "Trophies",
	"trophies_title": "Most trophies",
	"statistics": "Statistics",
	"no_results": "No results",
	"xp": "XP",
	"solo_tournaments_title": "Solo Tournaments Won",
	"farmer_tournaments_title": "Farmer Tournaments Won",
	"team_tournaments_title": "Team Tournaments Won",
	"tournaments": "Tournaments"
}

	Ranking.options.i18n = { messages: {en: messages }}
	export default Ranking